// LAN-1187: hold the space bar to record, release it to stop and send, like a
// long press on mobile's mic button. A short tap does nothing, and a space
// typed into a message that already has text stays a space.
const HOLD_MS = 200;

const CONTROL_ROLES = ['button', 'link', 'checkbox', 'radio', 'switch', 'menuitem', 'tab', 'option'];

// Fields and controls keep their own Space: typing, or activating a focused
// button, link or checkbox for keyboard users.
function control(element) {
  if (!element) return false;
  if (element.isContentEditable) return true;
  const tag = (element.tagName || '').toLowerCase();
  if (['textarea', 'select', 'input', 'button', 'a', 'summary'].includes(tag)) return true;
  return CONTROL_ROLES.includes(element.getAttribute?.('role'));
}

// recordBtn is a function: the recorder replaces the button node when the
// transcription mode changes.
function bindHoldToRecord({ doc, win, recordBtn, chatInput, isRecording, canStart, holdMs = HOLD_MS, timers = globalThis }) {
  let timer = null;
  let started = false;

  const forUs = target => {
    if (target === chatInput) return !chatInput.value.trim();
    // A mouse click leaves focus on the mic button; the hold still applies there.
    if (target === recordBtn()) return true;
    return !control(target);
  };

  const release = () => {
    timers.clearTimeout(timer);
    timer = null;
    if (!started) return;
    started = false;
    if (isRecording()) recordBtn().click();
  };

  const onKeyDown = event => {
    if (event.code !== 'Space' || event.ctrlKey || event.metaKey || event.altKey) return;
    // Auto-repeat while held: keep the spaces out of the message box.
    if (timer || started) return event.preventDefault();
    if (event.repeat || !forUs(event.target) || isRecording() || !canStart()) return;
    event.preventDefault();
    timer = timers.setTimeout(() => {
      timer = null;
      // A modal or auto-record may have arrived during the hold.
      if (isRecording() || !canStart()) return;
      started = true;
      recordBtn().click();
    }, holdMs);
  };

  const onKeyUp = event => {
    if (event.code !== 'Space' || (!timer && !started)) return;
    event.preventDefault();
    release();
  };

  doc.addEventListener('keydown', onKeyDown);
  doc.addEventListener('keyup', onKeyUp);
  // A keyup that lands in another window never reaches the page.
  win.addEventListener('blur', release);
  return () => {
    timers.clearTimeout(timer);
    doc.removeEventListener('keydown', onKeyDown);
    doc.removeEventListener('keyup', onKeyUp);
    win.removeEventListener('blur', release);
  };
}

module.exports = { bindHoldToRecord, HOLD_MS };
